import Vue from 'vue'
import App from './App.vue'

import router from './router/index'
import store from './store/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import Urls from './assets/js/Urls'
import axios from 'axios'


Vue.config.productionTip = false

window.Urls = Urls;
window.axios = axios
Vue.use(ElementUI);

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么

    // 设置post请求头
    if(config.method!='get' && config.headers['Content-Type'] != 'multipart/form-data' && !(config.data instanceof FormData)){
        config.headers['Content-Type'] = 'application/json';
    }

    // 设置请求头

    // 设置token
    const token = window.localStorage.getItem('token');
    if (token && token !== 'undefined')
        config.headers['token'] = token

    // if (config.url.indexOf('?') > -1) {
    //     config.url = config.url + "&timestamp=" + new Date().getTime();
    // } else {
    //     config.url = config.url + "?timestamp=" + new Date().getTime();
    // }
    return config;
}, function (error) {
    // 对响应错误做点什么
    if(error.response){
      if(error.response.status === 401 || error.response.status === 500){ // 接口返回401，token失效
          alert(err.response.data.errorMessage)
          router.replace && router.replace({name: 'Login'})
          window.localStorage.clear()
      }
    }
    return Promise.reject(error);
});

// 全局设置router跳转
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

new Vue({
    router,
    store,
  render: h => h(App),
}).$mount('#app')
